module.exports = __webpack_public_path__ + "img/marker.92f16c78.svg";